import { Record, Union } from "../../fable_modules/fable-library.3.6.3/Types.js";
import { tuple_type, lambda_type, class_type, record_type, float64_type, int32_type, bool_type, string_type, union_type, array_type, uint8_type } from "../../fable_modules/fable-library.3.6.3/Reflection.js";

export function Route_builder(typeName, methodName) {
    return `/obt_nett/api/${typeName}/${methodName}`;
}

export class FileByteArray extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["FileByteArray"];
    }
}

export function FileByteArray$reflection() {
    return union_type("Shared.FileByteArray", [], FileByteArray, () => [[["Item", array_type(uint8_type)]]]);
}

export class ContentHash extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ContentHash"];
    }
}

export function ContentHash$reflection() {
    return union_type("Shared.ContentHash", [], ContentHash, () => [[["Item", string_type]]]);
}

export class IncludePos extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["IncludePos"];
    }
}

export function IncludePos$reflection() {
    return union_type("Shared.IncludePos", [], IncludePos, () => [[["Item", bool_type]]]);
}

export class TaggedTextInfo extends Record {
    constructor(ContentHash, NumAllTokens, NumWordTokens, NumWordTypes, NumWordLemmaTypes, AvgWordLength, AvgSentenceLength) {
        super();
        this.ContentHash = ContentHash;
        this.NumAllTokens = (NumAllTokens | 0);
        this.NumWordTokens = (NumWordTokens | 0);
        this.NumWordTypes = (NumWordTypes | 0);
        this.NumWordLemmaTypes = (NumWordLemmaTypes | 0);
        this.AvgWordLength = AvgWordLength;
        this.AvgSentenceLength = AvgSentenceLength;
    }
}

export function TaggedTextInfo$reflection() {
    return record_type("Shared.TaggedTextInfo", [], TaggedTextInfo, () => [["ContentHash", ContentHash$reflection()], ["NumAllTokens", int32_type], ["NumWordTokens", int32_type], ["NumWordTypes", int32_type], ["NumWordLemmaTypes", int32_type], ["AvgWordLength", float64_type], ["AvgSentenceLength", float64_type]]);
}

export class DownloadFormat extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Excel", "Tsv", "Csv"];
    }
}

export function DownloadFormat$reflection() {
    return union_type("Shared.DownloadFormat", [], DownloadFormat, () => [[], [], []]);
}

export class IServerApi extends Record {
    constructor(TagText, DownloadTaggedText, GetLemmas, DownloadLemmas, DownloadLemmatizedText) {
        super();
        this.TagText = TagText;
        this.DownloadTaggedText = DownloadTaggedText;
        this.GetLemmas = GetLemmas;
        this.DownloadLemmas = DownloadLemmas;
        this.DownloadLemmatizedText = DownloadLemmatizedText;
    }
}

export function IServerApi$reflection() {
    return record_type("Shared.IServerApi", [], IServerApi, () => [["TagText", lambda_type(FileByteArray$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [TaggedTextInfo$reflection()]))], ["DownloadTaggedText", lambda_type(ContentHash$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [FileByteArray$reflection()]))], ["GetLemmas", lambda_type(ContentHash$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(tuple_type(tuple_type(string_type, string_type), int32_type))]))], ["DownloadLemmas", lambda_type(tuple_type(ContentHash$reflection(), DownloadFormat$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [FileByteArray$reflection()]))], ["DownloadLemmatizedText", lambda_type(tuple_type(ContentHash$reflection(), IncludePos$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [FileByteArray$reflection()]))]]);
}

